// src/pages/admin/Certifications.jsx
import React from 'react';
import AdminSidebar from '../../components/admin/AdminSidebar';
import CertificationManager from '../../components/admin/CertificationManager';

const Certifications = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar />
      <div className="flex-1 p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Manage Certifications</h1>
          <p className="text-gray-600">Add and manage company certifications and licenses</p>
        </div>
        <CertificationManager />
      </div>
    </div>
  );
};

export default Certifications;